import React, { useState } from "react";
import { Spin, Alert as AlertAntd, Typography } from "antd";
import AlertDialog from "./AlertDialog";
import { ReactComponent as MosquitoIconSvg } from "../../assets/icons/MosquitoVector.svg";
import { DetectionStatusData } from "../../types/components/home";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";

import "./index.css";

const { Title, Text } = Typography;

type Props = {
  loading: boolean;
  isFetchingMore: boolean;
  listContainerRef: React.RefObject<HTMLDivElement>;
  joinedAlerts: DetectionStatusData[];
  handleClickAlert: (id: string) => void;
};

const DetectionActivity: React.FC<Props> = ({
  loading,
  isFetchingMore,
  listContainerRef,
  joinedAlerts,
  handleClickAlert,
}) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="detection-box-container">
      <Spin spinning={loading}>
        <div
          className="detection-box-title"
          onClick={() => setExpanded((prev) => !prev)}
          style={{ cursor: "pointer" }}
        >
          <Title level={4} className="detection-box-title-text">
            Mosquito Detections
          </Title>
          {expanded ? (
            <ChevronUpIcon className="w-5 h-5 text-[#003A55]" />
          ) : (
            <ChevronDownIcon className="w-5 h-5 text-[#003A55]" />
          )}
        </div>
        {expanded ? (
          <div
            ref={listContainerRef}
            className={`detection-box-alerts ${
              joinedAlerts.length > 0 ? "has-alerts" : "no-alerts"
            }`}
          >
            {joinedAlerts.length > 0
              ? joinedAlerts.map((item: DetectionStatusData) => (
                  <AlertDialog
                    key={item._id}
                    item={item}
                    onClick={handleClickAlert}
                  />
                ))
              : !loading && (
                  <AlertAntd
                    message={<Text strong>No detections</Text>}
                    showIcon
                    type="success"
                    icon={
                      <MosquitoIconSvg
                        width={24}
                        height={24}
                        stroke="none"
                        fill="#22C55E"
                      />
                    }
                  />
                )}
          </div>
        ) : (
          <div className="alert-dialog-container alert-dialog-container--primary">
            <AlertAntd
              message={
                <Text className="font-bold">
                  {joinedAlerts.length} Mosquito detected
                </Text>
              }
              showIcon
              icon={<MosquitoIconSvg width={24} height={24} fill="#F4C000" />}
              type="warning"
            />
          </div>
        )}
      </Spin>
    </div>
  );
};

export { DetectionActivity };
